import { render, staticRenderFns } from "./base_dropdown.vue?vue&type=template&id=0bac35b6"
import script from "./base_dropdown.vue?vue&type=script&lang=js"
export * from "./base_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports